import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import { mediaMax, spacing } from 'presentations/views/styles';
import styled from '@emotion/styled';
import SectionTitle from 'presentations/views/components/molecules/ServiceSectionTitle';
import ContentItem5 from 'presentations/views/components/molecules/ServiceContentItem5';
import ServiceSubSectionTitle from 'presentations/views/components/molecules/ServiceSubSectionTitle';

export default function Component() {
  const t = translateInComponent(translations);
  return (
    <>
      <SectionTitle
        title={t('title')}
        titleEn={t('title en')}
        description={t('description')}
      />
      <SubSectionTitle title={t('item 1 title')} />
      <ListContainer2>
        <ListItem>
          <ContentItem5
            imageUrl="pages/features/design_1.png"
            imageWidth={440}
            imageHeight={300}
            title={t('item_1_titles.0')}
            description={t('item_1_descriptions.0')}
          />
        </ListItem>
        <ListItem>
          <ContentItem5
            imageUrl="pages/features/design_2.png"
            imageWidth={440}
            imageHeight={300}
            title={t('item_1_titles.1')}
            description={t('item_1_descriptions.1')}
          />
        </ListItem>
      </ListContainer2>
      <SubSectionTitle title={t('item 2 title')} />
      <ListContainer2>
        <ListItem>
          <ContentItem5
            imageUrl="pages/features/design_3.png"
            imageWidth={440}
            imageHeight={300}
            title={t('item_2_titles.0')}
            description={t('item_2_descriptions.0')}
          />
        </ListItem>
        <ListItem>
          <ContentItem5
            imageUrl="pages/features/design_4.png"
            imageWidth={440}
            imageHeight={300}
            title={t('item_2_titles.1')}
            description={t('item_2_descriptions.1')}
          />
        </ListItem>
        <ListItem>
          <ContentItem5
            imageUrl="pages/features/design_5.png"
            imageWidth={440}
            imageHeight={300}
            icon="card-account-details-outline"
            title={t('item_2_titles.2')}
            description={t('item_2_descriptions.2')}
          />
        </ListItem>
      </ListContainer2>
    </>
  );
}

const ListContainer2 = styled.div`
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  :last-of-type {
    margin-bottom: 0;
  }
  ${mediaMax.tablet} {
    width: auto;
    display: block;
    padding: 0 ${spacing(16)};
  }
`;

const ListItem = styled.div`
  width: 48%;
  :first-of-type {
    margin-right: ${spacing(32)};
  }
  ${mediaMax.tablet} {
    width: 100%;
    margin-bottom: ${spacing(48)};
    margin-right: 0;
  }
  margin-bottom: ${spacing(48)};
`;

const SubSectionTitle = styled(ServiceSubSectionTitle)`
  margin-bottom: ${spacing(32)};
`;
